import React from 'react';
import { Col, Form, Input, Row, Select, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { DateFee } from '../../../../../server/src/models';
import { DAY_OF_WEEK, FEE_APPLICATION_METHOD } from '../../../../../shared/enums/PriceMatrix';

const { Option } = Select;

interface DateFeeInputProps {
    isDetailMode: boolean;
    dateFee: DateFee | undefined;
    fieldName: number;
    remove: (index: number | number[]) => void;
}

const DateFeeInput: React.FC<DateFeeInputProps> = ({ isDetailMode, dateFee, fieldName, remove }: DateFeeInputProps) => {
    const daysOfWeek = [
        { value: DAY_OF_WEEK.SUNDAY, label: 'Sunday' },
        { value: DAY_OF_WEEK.MONDAY, label: 'Monday' },
        { value: DAY_OF_WEEK.TUESDAY, label: 'Tuesday' },
        { value: DAY_OF_WEEK.WEDNESDAY, label: 'Wednesday' },
        { value: DAY_OF_WEEK.THURSDAY, label: 'Thursday' },
        { value: DAY_OF_WEEK.FRIDAY, label: 'Friday' },
        { value: DAY_OF_WEEK.SATURDAY, label: 'Saturday' },
    ];
    const units = [
        { value: '%', label: '%' },
        { value: 'EUR', label: 'Euro' },
    ];
    const applyMethod = [
        { value: FEE_APPLICATION_METHOD.BASE_PRICE, label: 'Base price' },
        { value: FEE_APPLICATION_METHOD.TOTAL_PRICE, label: 'Total price' },
    ];
    return (
        <>
            <Row gutter={24}>
                <Col span={6} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }}>
                    <Form.Item
                        label={isDetailMode ? undefined : 'Day of the week'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'dayOfTheWeek']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? (
                            <span>{dateFee?.dayOfTheWeek}</span>
                        ) : (
                            <Select showArrow>
                                {daysOfWeek.map(({ value, label }) => (
                                    <Option key={value} value={value}>
                                        {label}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col span={5} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }}>
                    <Form.Item
                        label={isDetailMode ? undefined : 'Value'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'value']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? <span>{dateFee?.value}</span> : <Input type="number" />}
                    </Form.Item>
                </Col>
                <Col span={5} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }}>
                    <Form.Item
                        label={isDetailMode ? undefined : 'Unit'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'unit']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? (
                            <span>{dateFee?.unit}</span>
                        ) : (
                            <Select showArrow>
                                {units.map(({ value, label }) => (
                                    <Option key={value} value={value}>
                                        {label}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                <Col span={6} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }}>
                    <Form.Item
                        label={isDetailMode ? undefined : 'Apply on'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'applyMethod']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? (
                            <span>{dateFee?.applyMethod}</span>
                        ) : (
                            <Select showArrow>
                                {applyMethod.map(({ value, label }) => (
                                    <Option key={value} value={value}>
                                        {label}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Col>
                {!isDetailMode && (
                    <Col span={1} offset={1}>
                        <span className="ant-form-text text-secondary" style={{ marginTop: '5px', cursor: 'pointer' }}>
                            <Tag
                                color="warning"
                                style={{ cursor: 'pointer' }}
                                onClick={(): void => remove?.(fieldName)}
                                id={`date_fee_delete_${fieldName}`}
                            >
                                <DeleteOutlined />
                            </Tag>
                        </span>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default DateFeeInput;
